import React from "react"
import "./src/styles/global.css"
import ScrollTrigger from "gsap/ScrollTrigger"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { CartProvider } from "./src/context/CartContext"
export function onRouteUpdate() {
  // Ejecutar la lógica de GSAP (como lo tienes)
  ScrollTrigger.getAll().forEach(trigger => trigger.kill())

  setTimeout(() => {
    ScrollTrigger.refresh()
  }, 500)
}

export const wrapRootElement = ({ element }) => (
  <CartProvider>{element}</CartProvider>
)

// export const onInitialClientRender = () => {
//   const storedLang = localStorage.getItem("gatsby-i18next-language")

//   if (!storedLang) {
//     changeLanguage("es")
//     localStorage.setItem("gatsby-i18next-language", "es")
//   }
// }
